// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2V33m","head":"Table_head__1Wh0N","col":"Table_col__2wdCD"};